import { MaskProps } from '@react-input/mask';
import classNames from 'classnames';
import { useState, ReactElement, cloneElement, BaseSyntheticEvent } from 'react';
import { FormControlProps } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import './CustomizedInput.scss';
import { UseFormRegister } from 'react-hook-form';
import {
  ExtraIncomeFieldType,
  ExtraIncomeFormType,
} from '../BookingRequestDialog/ExtraIncomeForms';
import { getSuffixInputIcon } from './CustomizedInput.utils';

export interface ICustomizedInputProps extends FormControlProps {
  title?: string;
  type?: string;
  step?: string;
  isLoading?: boolean;
  errorMessage?: string;
  suffixIcon?: ReactElement | null;
  suffixEmptyIcon?: ReactElement | null;
  suffixFocusIcon?: ReactElement | null;
  titleClassName?: string;
  inputClassName?: string;
  containerClassName?: string;
  suffixClassNames?: string;
  suffixFocusedClassName?: string;
  isEmpty: boolean;
  onChange?: (event: { target: any; type?: any }) => void;
  register: UseFormRegister<ExtraIncomeFormType>;
  name: ExtraIncomeFieldType;
  submitHandler?: (e: any) => Promise<void>;
  onBlurHandler?: () => void;
}

export const CustomizedInput = ({
  title,
  isLoading,
  type,
  errorMessage,
  inputClassName,
  containerClassName,
  titleClassName,
  suffixIcon = null,
  suffixFocusIcon = null,
  suffixEmptyIcon = null,
  suffixClassNames,
  suffixFocusedClassName = '',
  isEmpty,
  value,
  register,
  onChange,
  name,
  submitHandler,
  onBlurHandler,
  ...rest
}: ICustomizedInputProps & MaskProps) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const icon = getSuffixInputIcon({
    suffixIcon,
    suffixFocusIcon,
    suffixEmptyIcon,
    isEmpty,
    isFocused,
  });

  const onClick = (e: BaseSyntheticEvent) => {
    if (!isFocused) {
      return;
    }
    submitHandler?.(e);
  };

  return (
    <div className={classNames('customized-input-wrapper', [containerClassName])}>
      {title ? (
        <p className={classNames('customized-input-title m-0 pb-1', [titleClassName])}>{title}</p>
      ) : null}
      <Form.Group className="position-relative w-100">
        <div className="position-relative customized-input-field-wrapper">
          {suffixIcon || suffixFocusIcon || suffixEmptyIcon ? (
            <div
              className={classNames('customized-input-prefix', [suffixClassNames], {
                [suffixFocusedClassName]: isFocused,
                'bg-white': !!errorMessage,
              })}
            >
              {icon ? cloneElement(icon, { onClick }) : icon}
            </div>
          ) : null}
          <Form.Control
            value={value}
            type={type}
            className={classNames('customized-input-field-input', [inputClassName], {
              'has-prefix': suffixIcon || suffixFocusIcon || suffixEmptyIcon,
            })}
            disabled={isLoading}
            isInvalid={!!errorMessage}
            onFocus={() => setIsFocused(true)}
            {...register(name, {
              onChange,
              onBlur: () => {
                setTimeout(() => setIsFocused(false), 200);
                onBlurHandler?.();
              },
            })}
            {...rest}
          />
        </div>
        <Form.Control.Feedback
          tooltip
          type="invalid"
          className={classNames({ 'customized-input-error': !!errorMessage })}
        >
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
};
